(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vensique-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vq-scroll-scene')) {
  customElements.define('vq-scroll-scene', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
      this.motionPreference.addEventListener('change', () => this.setup(), { signal: this.controller.signal });
      this.setup();
      document.addEventListener('scroll', () => this.schedule(), { passive: true, capture: true, signal: this.controller.signal });
      window.addEventListener('resize', () => this.schedule(), { passive: true, signal: this.controller.signal });
      this.addEventListener('focusin', event => {
        const target = event.target.closest('[data-vq-reveal]');
        if (target) target.classList.add('vq-in-view');
      }, { signal: this.controller.signal });
    }
    setup() {
      this.observer?.disconnect();
      this.classList.remove('vq-motion-ready');
      if (this.motionPreference.matches) return;
      const elements = this.querySelectorAll('.vq-intro > p, .vq-intro > h2, .vq-worlds > div, .vq-story__content > *, .vq-collection__heading, .vq-coming, .vq-product');
      elements.forEach((element, index) => {
        element.setAttribute('data-vq-reveal', '');
        element.style.setProperty('--vq-delay', `${element.matches('.vq-worlds > div, .vq-product') ? (index % 3) * 80 : 0}ms`);
        element.classList.toggle('vq-in-view', element.getBoundingClientRect().top < innerHeight * .94);
      });
      this.hero = this.querySelector('.vq-hero');
      this.story = this.querySelector('.vq-story');
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('vq-in-view');
            this.observer.unobserve(entry.target);
          }
        });
      }, { threshold: .08, rootMargin: '0px 0px -24px 0px' });
      elements.forEach(element => this.observer.observe(element));
      this.classList.add('vq-motion-ready');
      this.schedule();
    }
    schedule() {
      if (this.frame || this.motionPreference.matches) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        if (!this.isConnected) return;
        const desktop = innerWidth >= 1000;
        const hero = this.hero?.getBoundingClientRect();
        if (hero && hero.bottom > 0 && hero.top < innerHeight) {
          const progress = Math.max(0, Math.min(1, -hero.top / hero.height));
          this.style.setProperty('--vq-hero-y', `${progress * (desktop ? 65 : 24)}px`);
          this.style.setProperty('--vq-hero-scale', `${1.04 + progress * .10}`);
          this.style.setProperty('--vq-copy-y', `${progress * (desktop ? -38 : -16)}px`);
        }
        const story = this.story?.getBoundingClientRect();
        if (story && story.bottom > 0 && story.top < innerHeight) {
          const progress = Math.max(0, Math.min(1, (innerHeight - story.top) / (innerHeight + story.height)));
          this.style.setProperty('--vq-story-scale', `${1 + progress * .025}`);
        }
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vensique-runway"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('vq-atelier')) {
  customElements.define('vq-atelier', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.disconnected = false;
      if (document.readyState === 'loading' && !this.querySelector('[data-carousel-stage]')) {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), {once: true, signal: this.abort.signal});
      } else {
        this.initialize();
      }
    }

    initialize() {
      if (this.disconnected) return;
      const signal = this.abort.signal;
      this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
      this.finePointer = matchMedia('(hover: hover) and (pointer: fine)');
      this.stage = this.querySelector('[data-carousel-stage]');
      this.carousel = this.querySelector('[data-carousel]');
      this.cards = this.carousel ? [...this.carousel.querySelectorAll('.va-card[data-vr-open]')] : [];
      this.label = this.querySelector('[data-carousel-label]');
      this.motionButtons = [...this.querySelectorAll('[data-motion-toggle]')];
      this.userPaused ??= this.motionPreference.matches;
      this.motionOptIn ??= false;
      this.keyboardInput = document.activeElement?.matches(':focus-visible') || false;
      this.angle = 0;
      this.targetAngle = 0;
      this.stepAngle = this.cards.length ? 360 / this.cards.length : 360;
      this.activeIndex = -1;
      this.visible = true;
      this.stageVisible = true;
      this.hovered = false;
      this.focused = this.hasKeyboardFocus();
      this.pendingAnnouncement = false;
      this.lastTime = 0;
      this.frame = 0;
      this.suppressClickUntil = 0;
      this.drag = null;
      this.dialogs = [...this.querySelectorAll('dialog')];
      this.addEventListener('click', event => this.handleClick(event), {signal, capture: true});
      this.addEventListener('focusin', event => {
        this.focused = this.hasKeyboardFocus();
        event.target.closest('.va-reveal')?.classList.remove('is-pending');
        this.syncMotion();
      }, {signal});
      this.addEventListener('focusout', () => {
        queueMicrotask(() => {
          if (signal.aborted) return;
          this.focused = this.hasKeyboardFocus();
          this.syncMotion();
        });
      }, {signal});
      document.addEventListener('pointerdown', () => {
        this.keyboardInput = false;
        this.focused = false;
        this.syncMotion();
      }, {signal, capture: true, passive: true});
      document.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        this.keyboardInput = true;
        this.focused = this.hasKeyboardFocus();
        this.syncMotion();
      }, {signal, capture: true});
      document.addEventListener('visibilitychange', () => this.syncMotion(), {signal});
      this.motionPreference.addEventListener('change', () => {
        this.motionOptIn = false;
        if (this.motionPreference.matches) this.userPaused = true;
        this.resetTilts();
        this.setupReveals();
        this.syncMotion();
        this.schedule();
      }, {signal});
      this.finePointer.addEventListener('change', () => this.resetTilts(), {signal});

      if (this.stage && this.carousel && this.cards.length) {
        this.classList.add('has-carousel');
        this.stage.setAttribute('tabindex', '0');
        this.stage.style.touchAction = 'pan-y';
        if (this.label) {
          this.label.setAttribute('aria-live', 'off');
          this.label.removeAttribute('role');
        }
        this.status = this.querySelector('[data-carousel-status]');
        if (!this.status) {
          this.status = document.createElement('span');
          this.status.dataset.carouselStatus = '';
          this.status.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0';
          this.stage.insertAdjacentElement('afterend', this.status);
        }
        this.status.setAttribute('role', 'status');
        this.status.setAttribute('aria-live', 'polite');
        this.status.setAttribute('aria-atomic', 'true');
        this.status.textContent = '';
        this.measure();
        this.stage.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse' || !this.finePointer.matches) return;
          this.hovered = true;
          this.syncMotion();
        }, {signal});
        this.stage.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.syncMotion();
        }, {signal});
        this.stage.addEventListener('pointerdown', event => this.startDrag(event), {signal});
        this.stage.addEventListener('pointermove', event => this.moveDrag(event), {signal, passive: false});
        window.addEventListener('pointerup', event => this.finishDrag(event), {signal});
        window.addEventListener('pointercancel', event => this.finishDrag(event, true), {signal});
        this.stage.addEventListener('lostpointercapture', event => this.finishDrag(event, true), {signal});
        this.stage.addEventListener('dragstart', event => event.preventDefault(), {signal});
        this.stage.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') {
            this.goTo(event.key === 'Home' ? 0 : this.cards.length - 1);
          } else {
            this.advance(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, {signal});
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.measure());
          this.resizeObserver.observe(this.stage);
          this.resizeObserver.observe(this.carousel);
        } else {
          window.addEventListener('resize', () => this.measure(), {signal, passive: true});
        }
      }

      this.dialogs.forEach(dialog => {
        if (dialog.parentElement !== this) this.append(dialog);
        dialog.addEventListener('close', () => { if (!dialog.open) this.dialogClosed(dialog); }, {signal});
        dialog.addEventListener('cancel', event => {
          event.preventDefault();
          this.closeDialog(dialog);
        }, {signal});
        dialog.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.target.closest('input,textarea,select')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.showPhoto(dialog, Number(dialog.dataset.photoIndex || 0) + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, {signal});
      });
      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target === this) this.visible = entry.isIntersecting;
            if (entry.target === this.stage) this.stageVisible = entry.isIntersecting;
          });
          this.syncMotion();
        }, {threshold: 0});
        this.visibilityObserver.observe(this);
        if (this.stage) this.visibilityObserver.observe(this.stage);
      }
      this.setupReveals();
      this.setupTilts();
      this.syncMotion();
    }

    measure() {
      if (!this.carousel || !this.cards.length) return;
      const width = this.carousel.offsetWidth || (innerWidth < 600 ? 160 : 220);
      this.radius = this.cards.length > 2 ? width / (2 * Math.tan(Math.PI / this.cards.length)) + 35 : width;
      this.carousel.style.setProperty('--carousel-radius', `${this.radius.toFixed(2)}px`);
      this.cards.forEach((card, index) => {
        card.style.transform = `rotateY(${index * this.stepAngle}deg) translateZ(${this.radius.toFixed(2)}px)`;
      });
      this.render();
    }

    hasKeyboardFocus() {
      const active = document.activeElement;
      return this.keyboardInput && this.contains(active) && !active?.closest('[data-motion-toggle]');
    }

    reducedMotion() {
      return this.motionPreference.matches && !this.motionOptIn;
    }

    canAutoRotate() {
      return this.cards.length > 1 && !this.userPaused && !this.reducedMotion() && !document.hidden &&
        this.visible && this.stageVisible && !this.hovered && !this.focused && !this.drag && !this.openDialog && !this.pendingAnnouncement;
    }

    syncMotion() {
      const paused = this.userPaused || this.reducedMotion() || document.hidden || !this.visible || this.hovered || this.focused || Boolean(this.openDialog);
      this.classList.toggle('is-paused', paused);
      this.classList.toggle('is-motion-enabled', this.motionOptIn && !this.userPaused);
      this.motionButtons.forEach(button => {
        const explicitlyPaused = this.userPaused || this.reducedMotion();
        button.setAttribute('aria-pressed', String(explicitlyPaused));
        const text = explicitlyPaused ? button.dataset.playLabel : button.dataset.pauseLabel;
        const label = button.querySelector('[data-motion-label]') || button;
        if (text) label.textContent = text;
        button.disabled = false;
      });
      this.schedule();
    }

    schedule() {
      if (this.frame || this.disconnected || !this.carousel || !this.cards.length) return;
      if (!this.canAutoRotate() && Math.abs(this.targetAngle - this.angle) < 0.01 && !this.pendingAnnouncement) return;
      this.frame = requestAnimationFrame(time => this.tick(time));
    }

    tick(time) {
      this.frame = 0;
      if (this.disconnected) return;
      const elapsed = this.lastTime ? Math.min(64, Math.max(1, time - this.lastTime)) : 16;
      this.lastTime = time;
      if (this.canAutoRotate()) this.targetAngle += elapsed * 0.002;
      const delta = this.targetAngle - this.angle;
      this.angle = this.reducedMotion() || Math.abs(delta) < 0.02 ? this.targetAngle : this.angle + delta * (1 - Math.exp(-elapsed / 95));
      this.render();
      if (this.pendingAnnouncement && !this.drag && Math.abs(this.targetAngle - this.angle) < 0.04) {
        this.pendingAnnouncement = false;
        this.announce();
      }
      this.schedule();
      if (!this.frame) this.lastTime = 0;
    }

    render() {
      if (!this.carousel || !this.cards.length) return;
      this.carousel.style.transform = `translateZ(-${this.radius.toFixed(2)}px) rotateY(${-this.angle.toFixed(3)}deg)`;
      this.cards.forEach((card, index) => {
        let distance = ((index * this.stepAngle - this.angle) % 360 + 540) % 360 - 180;
        const dim = Math.min(Math.abs(distance) / 150, 1);
        card.style.opacity = String(1 - dim * 0.62);
        card.style.filter = `brightness(${1 - dim * 0.36})`;
      });
      const index = this.wrap(Math.round(this.angle / this.stepAngle));
      if (index === this.activeIndex) return;
      const moveKeyboardFocus = this.cards.includes(document.activeElement);
      this.activeIndex = index;
      this.cards.forEach((card, i) => {
        card.tabIndex = i === index ? 0 : -1;
        card.setAttribute('aria-hidden', String(i !== index));
        card.classList.toggle('is-active', i === index);
        if (i === index) card.setAttribute('aria-current', 'true');
        else card.removeAttribute('aria-current');
      });
      if (moveKeyboardFocus) this.cards[index].focus({preventScroll: true});
      if (this.label) this.label.textContent = this.cardTitle(index);
      [index, this.wrap(index - 1), this.wrap(index + 1)].forEach(i => this.loadImages(this.cards[i]));
    }

    wrap(index) {
      return (index % this.cards.length + this.cards.length) % this.cards.length;
    }

    cardTitle(index) {
      return this.cards[index]?.dataset.title || this.cards[index]?.textContent.trim() || '';
    }

    announce() {
      if (this.status) this.status.textContent = `${this.activeIndex + 1} / ${this.cards.length}: ${this.cardTitle(this.activeIndex)}`;
    }

    advance(direction) {
      if (!this.cards.length) return;
      this.targetAngle = (Math.round(this.targetAngle / this.stepAngle) + direction) * this.stepAngle;
      this.pendingAnnouncement = true;
      this.schedule();
    }

    goTo(index, immediate = false) {
      const current = Math.round(this.targetAngle / this.stepAngle);
      let delta = this.wrap(index) - this.wrap(current);
      if (delta > this.cards.length / 2) delta -= this.cards.length;
      if (delta < -this.cards.length / 2) delta += this.cards.length;
      this.targetAngle = (current + delta) * this.stepAngle;
      this.pendingAnnouncement = true;
      if (immediate) {
        this.angle = this.targetAngle;
        this.render();
        this.pendingAnnouncement = false;
      }
      this.schedule();
    }

    startDrag(event) {
      if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0) || this.cards.length < 2) return;
      this.targetAngle = this.angle;
      this.drag = {id: event.pointerId, x: event.clientX, y: event.clientY, angle: this.angle, axis: '', moved: false};
      this.syncMotion();
    }

    moveDrag(event) {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.id) return;
      const dx = event.clientX - drag.x;
      const dy = event.clientY - drag.y;
      if (!drag.axis && Math.max(Math.abs(dx), Math.abs(dy)) > 7) {
        drag.axis = Math.abs(dx) > Math.abs(dy) * 1.15 ? 'x' : 'y';
        if (drag.axis === 'x') {
          drag.moved = true;
          this.stage.setPointerCapture?.(event.pointerId);
          this.stage.classList.add('is-dragging');
        }
      }
      if (drag.axis !== 'x') return;
      if (event.cancelable) event.preventDefault();
      this.targetAngle = drag.angle - dx * (this.carousel.offsetWidth <= 160 ? 0.32 : 0.24);
      this.schedule();
    }

    finishDrag(event, cancelled = false) {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.id) return;
      this.drag = null;
      this.stage.classList.remove('is-dragging');
      if (this.stage.hasPointerCapture?.(event.pointerId)) this.stage.releasePointerCapture(event.pointerId);
      if (drag.moved) {
        this.suppressClickUntil = performance.now() + 500;
        this.targetAngle = Math.round(this.targetAngle / this.stepAngle) * this.stepAngle;
        this.pendingAnnouncement = !cancelled;
      }
      this.syncMotion();
    }

    handleClick(event) {
      if (!(event.target instanceof Element)) return;
      const opener = event.target.closest('[data-vr-open]');
      if (opener && this.stage?.contains(opener) && performance.now() < this.suppressClickUntil) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.suppressClickUntil = 0;
        return;
      }
      const motion = event.target.closest('[data-motion-toggle]');
      if (motion) {
        this.userPaused = !this.userPaused;
        this.motionOptIn = !this.userPaused && this.motionPreference.matches;
        this.focused = this.hasKeyboardFocus();
        if (this.userPaused) this.resetTilts();
        this.syncMotion();
        return;
      }
      const step = event.target.closest('[data-carousel-step]');
      if (step) {
        this.advance(Number(step.dataset.carouselStep) < 0 ? -1 : 1);
        return;
      }
      const photoStep = event.target.closest('[data-photo-step]');
      if (photoStep) {
        const dialog = photoStep.closest('dialog');
        if (dialog) this.showPhoto(dialog, Number(dialog.dataset.photoIndex || 0) + Number(photoStep.dataset.photoStep));
        return;
      }
      if (opener) {
        const dialog = this.dialogs.find(item => item.id === `vr-dialog-${opener.dataset.vrOpen}`);
        if (!dialog) return;
        event.preventDefault();
        if (this.stage?.contains(opener)) this.goTo(this.cards.indexOf(opener), true);
        this.showDialog(dialog, opener);
        return;
      }
      const closer = event.target.closest('[data-vr-close]');
      if (closer) {
        this.closeDialog(closer.closest('dialog'));
        return;
      }
      if (event.target instanceof HTMLDialogElement && event.target.open) {
        const rect = event.target.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeDialog(event.target);
      }
    }

    showDialog(dialog, opener) {
      if (dialog.open || typeof dialog.showModal !== 'function') return;
      if (this.openDialog) this.closeDialog(this.openDialog, false);
      this.returnFocus = opener;
      this.openDialog = dialog;
      dialog.hidden = false;
      dialog.classList.remove('is-pending');
      this.showPhoto(dialog, 0);
      this.savedScroll = {
        rootOverflow: document.documentElement.style.overflow,
        bodyOverflow: document.body.style.overflow,
        bodyPaddingRight: document.body.style.paddingRight,
        x: window.scrollX,
        y: window.scrollY
      };
      try {
        dialog.showModal();
      } catch (error) {
        this.openDialog = null;
        this.savedScroll = null;
        this.syncMotion();
        return;
      }
      const gutter = Math.max(0, innerWidth - document.documentElement.clientWidth);
      if (gutter) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight || '0') + gutter}px`;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      dialog.querySelector('[data-vr-close]')?.focus({preventScroll: true});
      this.syncMotion();
    }

    closeDialog(dialog, restoreFocus = true) {
      if (!dialog) return;
      this.skipFocusReturn = !restoreFocus;
      if (dialog.open) dialog.close();
      this.dialogClosed(dialog);
    }

    dialogClosed(dialog) {
      if (this.openDialog !== dialog) return;
      this.openDialog = null;
      const scroll = this.savedScroll;
      this.savedScroll = null;
      if (scroll) {
        document.documentElement.style.overflow = scroll.rootOverflow;
        document.body.style.overflow = scroll.bodyOverflow;
        document.body.style.paddingRight = scroll.bodyPaddingRight;
        if (Math.abs(window.scrollY - scroll.y) > 1 || Math.abs(window.scrollX - scroll.x) > 1) window.scrollTo({left: scroll.x, top: scroll.y, behavior: 'instant'});
      }
      if (!this.skipFocusReturn && this.returnFocus?.isConnected) this.returnFocus.focus({preventScroll: true});
      this.skipFocusReturn = false;
      this.returnFocus = null;
      this.syncMotion();
    }

    showPhoto(dialog, index) {
      const photos = [...dialog.querySelectorAll('.vr-dialog__photos img, [data-dialog-photo]')];
      if (!photos.length) return;
      const active = (index % photos.length + photos.length) % photos.length;
      dialog.dataset.photoIndex = String(active);
      photos.forEach((photo, i) => {
        photo.hidden = i !== active;
        photo.style.display = i === active ? '' : 'none';
        if (i === active) this.loadImage(photo);
      });
      const counter = dialog.querySelector('[data-photo-count]');
      if (counter) counter.textContent = `${active + 1} / ${photos.length}`;
      dialog.querySelectorAll('[data-photo-step]').forEach(button => { button.disabled = photos.length < 2; });
    }

    loadImage(image) {
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      if (image.dataset.src) image.src = image.dataset.src;
      if (image.dataset.sizes) image.sizes = image.dataset.sizes;
      image.loading = 'eager';
      image.decoding = 'async';
    }

    loadImages(container) {
      container?.querySelectorAll('img').forEach(image => this.loadImage(image));
    }

    setupReveals() {
      this.revealObserver?.disconnect();
      const revealElements = [...this.querySelectorAll('.va-reveal')];
      revealElements.forEach(element => element.classList.remove('is-pending'));
      if (this.motionPreference.matches || !('IntersectionObserver' in window)) {
        revealElements.forEach(element => element.classList.add('is-visible'));
        return;
      }
      this.revealObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('is-pending');
          entry.target.classList.add('is-visible');
          this.loadImages(entry.target);
          this.revealObserver.unobserve(entry.target);
        });
      }, {threshold: 0.04, rootMargin: '0px 0px 90px 0px'});
      revealElements.forEach((element, index) => {
        if (element.getBoundingClientRect().top > innerHeight && !element.classList.contains('is-visible')) {
          element.classList.add('is-pending');
          element.style.setProperty('--reveal-delay', `${index % 3 * 60}ms`);
        }
        this.revealObserver.observe(element);
      });
    }

    setupTilts() {
      const signal = this.abort.signal;
      this.tiltElements = [...this.querySelectorAll('.va-tilt, [data-hero-scene]')];
      this.tiltElements.forEach(element => {
        const surface = element.matches('[data-hero-scene]') ? (element.closest('.va-hero') || element) : element;
        surface.addEventListener('pointermove', event => {
          if (event.pointerType !== 'mouse' || !this.finePointer.matches || this.motionPreference.matches || this.userPaused) return;
          const rect = surface.getBoundingClientRect();
          if (!rect.width || !rect.height) return;
          const x = Math.max(-1, Math.min(1, ((event.clientX - rect.left) / rect.width - 0.5) * 2));
          const y = Math.max(-1, Math.min(1, ((event.clientY - rect.top) / rect.height - 0.5) * 2));
          element.style.setProperty('--rx', `${(-y * 3).toFixed(2)}deg`);
          element.style.setProperty('--ry', `${(x * 3).toFixed(2)}deg`);
        }, {signal, passive: true});
        surface.addEventListener('pointerleave', () => this.resetTilt(element), {signal});
      });
    }

    resetTilt(element) {
      element.style.setProperty('--rx', '0deg');
      element.style.setProperty('--ry', '0deg');
    }

    resetTilts() {
      this.tiltElements?.forEach(element => this.resetTilt(element));
    }

    disconnectedCallback() {
      this.disconnected = true;
      if (this.openDialog) this.closeDialog(this.openDialog, false);
      this.abort?.abort();
      this.visibilityObserver?.disconnect();
      this.revealObserver?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.lastTime = 0;
      this.drag = null;
      this.resetTilts();
      this.querySelectorAll('.is-pending').forEach(element => element.classList.remove('is-pending'));
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
